import { render } from "./VersionManage.vue?vue&type=template&id=64c3b330&scoped=true"
import script from "./VersionManage.vue?vue&type=script&lang=js"
export * from "./VersionManage.vue?vue&type=script&lang=js"

import "./VersionManage.vue?vue&type=style&index=0&id=64c3b330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3b330"]])

export default __exports__